<template>
  <div class="container">
    <div class="half-container input-wrapper">
      <input type="text" name="" :placeholder="placeholder" v-model="email" />
    </div>
    <div class="half-container right-container">
      <div class="component-wrapper">
        <div class="buttons-wrapper">
          <a v-on:click.prevent="downloadPng">PNG &darr;</a>
          <a v-on:click.prevent="downloadSvg">SVG &darr;</a>
        </div>
        <a v-on:click.prevent="downloadPack" class="button">{{ text }} &darr;</a>
      </div>
      <div class="send-wrapper">
        <a v-on:click.prevent="sendMail" class="button">{{ button }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import domtoimage from 'dom-to-image';
  import axios from 'axios';

  export default {
    props: {
      text: String,
      placeholder: String,
      button: String
    },

    data () {
      return {
        email: '',
        png: '',
        svg: '',
        basePath: 'origen',
        generationError: 'not generated!'
      };
    },

    methods: {
      sendMail () {
        const clone = this.cloneAndReveal();

        domtoimage
          .toPng(clone)
          .then(png => {
            this.png = png;

            domtoimage
              .toSvg(clone)
              .then(svg => {
                this.svg = svg;
                this.callAjax(this.png, this.svg);
              })
              .catch(function (error) {
                throw new Error(`Svg ${this.generationError}`, error);
            });
          })
          .catch(function (error) {
            throw new Error(`Png ${this.generationError}`, error);
        });
      },
      callAjax (png, svg) {
        axios.post('/', { email: this.email, png: png, svg: svg }).catch(error => {
          throw new Error('Error sending email!', error);
        });
      },
      downloadPack () {
        this.downloadSvg();
        this.downloadPng();
      },
      save (dataUrl, name, canvas = null) {
        const lnk = document.createElement('a');
        const clone = document.getElementById('clone');

        let e;

        lnk.download = name;
        lnk.href = dataUrl;

        if (document.createEvent) {
          e = document.createEvent('MouseEvents');
          e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          lnk.dispatchEvent(e);
        } else if (lnk.fireEvent) {
          lnk.fireEvent('onclick');
        }

        lnk.remove();
        clone.remove();
      },
      downloadPng () {
        const clone = this.cloneAndReveal();

        domtoimage
          .toPng(clone)
          .then(dataUrl => this.save(dataUrl, `${this.basePath}.png`))
          .catch(error => { throw new Error(`Png ${this.generationError}`, error); });
      },
      downloadSvg () {
        const clone = this.cloneAndReveal();

        domtoimage
          .toSvg(clone)
          .then(dataUrl => { this.save(dataUrl, `${this.basePath}.svg`); })
          .catch(error => { throw new Error(`Svg ${this.generationError}`, error); });
      },
      cloneAndReveal () {
        const node = document.getElementById('logo');
        const clone = node.cloneNode(true);
        const dropper = document.querySelector('.image-dropper');
        const svg = clone.querySelectorAll('svg')[0];

        clone.setAttribute('id', 'clone');
        clone.querySelectorAll('#name')[0].style.display = 'block';
        svg.style.width = '1086px';
        svg.style.height = '800px';
        dropper.appendChild(clone);

        return clone;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/DownloadLogo.vue